<template>
    <div class="row">
        <div class="col-12">
            <h1>{{ workflow.title }}</h1>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    mounted() {
        this.fetchWorkflow().then(() => {
            this.loading = false
        })
    },
    data() {
        return {
            loading: true,
            workflow: {
                title: ''
            },
        }
    },
    methods: {
        fetchWorkflow() {
            return this.$cfetch(`${this.$settings.APIBaseURL}/workflows/get`, {
                method: 'GET',
                data: {
                    id: this.$route.params.workflowId
                }
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching workflow')

                this.workflow = res.result
            }).catch(err => {
                console.error(err)
                this.$log.error.call(this, err)

                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-fetching-workflow'),
                    confirmCallBack: () => {
                        this.$router.push('/')
                    }
                })
            })
        }
    },
}
</script>